import React from 'react';

import type { IImage, IMimeMapping } from './models';

const mimeMapping: IMimeMapping = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    svg: 'image/svg+xml',
    webp: 'image/webp',
};

export const calcPadding = (height: number, width: number) => (height / width) * 100;

const getMimeType = (src: string): string => {
    const extension = src.split('.').pop() as string;

    return mimeMapping[extension];
};

export const getSources = (images: IImage[] | string[]) => {
    return images.map(image => {
        let src;
        let mimeType;

        if (typeof image === 'string') {
            src = image;
            mimeType = getMimeType(src);
        } else {
            // Объявленная переменная с присваиванием, линтер не выйдет пофиксить
            // eslint-disable-next-line prefer-destructuring
            src = image.src;
            mimeType = image.type ? image.type : getMimeType(src);
        }

        return <source key={src} srcSet={src} type={mimeType} />;
    });
};
